import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    ButtonBase,
} from '@material-ui/core';

import PropTypes from 'prop-types';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';

const ICON_DEL = require("../../images/icons/shanchu_icon.png");

class MSectionHeader extends React.Component {

    render() {
        const { classes, title, subtitle, chevron, marginTop, marginBottom, color, lineColor, del } = this.props;
        return (
            <ButtonBase disableRipple onClick={() => this.props.onClick && this.props.onClick()}>
                <Grid container direction='row' alignItems='center' justify='space-between' style={{ width: '100vw' }}  >
                    <Grid container direction='row' alignItems='center' style={{ width: '70%' }}>
                        {
                            lineColor && <Grid className={classes.line} style={{ backgroundColor: lineColor }} />
                        }
                        <Typography className={classes.title} style={{
                            marginTop: marginTop ? marginTop : 16,
                            marginBottom: marginBottom ? marginBottom : 16,
                            color: color ? color : '#0D0D0D'
                        }}>{title}</Typography>
                    </Grid>
                    {
                        subtitle && <Grid container direction='row' alignItems='center' justify='flex-end' style={{ flex: 1, paddingRight: 8 }}>
                            <Typography className={classes.subtitle}>{subtitle}</Typography>
                            {
                                chevron && <ChevronRightOutlinedIcon className={classes.chevron} />
                            }
                            {
                                del && <ButtonBase className={classes.del} >
                                    <img src={ICON_DEL} style={{ width: 12, height: 12 }}></img>
                                </ButtonBase>
                            }
                        </Grid>
                    }
                </Grid>
            </ButtonBase>
        );
    }
}

MSectionHeader.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    chevron: PropTypes.bool,
    marginTop: PropTypes.number,
    marginBottom: PropTypes.number,
    color: PropTypes.string,
    lineColor: PropTypes.string,
    del: PropTypes.bool
}


export default withStyles((theme) => ({
    line: {
        width: 3,
        height: 15,
        borderRadius: 1.5,
        margin: theme.spacing(2, 0, 2, 1),
    },
    title: {
        margin: theme.spacing(2, 0, 2, 1),
        height: theme.typography.pxToRem(18),
        fontWeight: 'bold',
        fontSize: 14,
        color: theme.palette.common.default,
    },
    subtitle: {
        margin: theme.spacing(2, 0, 2, 0),
        height: theme.typography.pxToRem(18),
        color: '#898989',
        fontSize: 12,
    },
    chevron: {
        color: theme.palette.common.default,
        fontSize: 16,
    },
    del: {
        color: '#878787',
        fontSize: 16,
    }

}))(MSectionHeader);